<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div
  class="ui vertical basic segment"
  *ngIf="success || error"
  appMargin
  marginB="10px"
>
  <esl-message-toast [(message)]="error"></esl-message-toast>
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
</div>
<h3 class="ui primary header">Network Operator’s Assessment</h3>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <ng-container>
      <div class="ui basic segment" appPadding paddingX="0">
        <div fxLayoutAlign="end"></div>
        <div class="ui vertical segment">
          <div appMargin marginB="20px">
            <div fxLayout="row" style="font-weight: 600">CREATED BY</div>
            <br />
            <div fxLayout="row">
              <small appMargin marginR="10px">
                <i class="user icon"></i>
                {{ organizationData.organizationAol.createdBy | createdBy }}
              </small>
              <small>
                <i class="clock outline icon"></i>
                {{
                  organizationData.organizationAol.dateCreated | date: "medium"
                }}
              </small>
            </div>
          </div>
        </div>
      </div>
      <ng-container>
        <div appMargin marginB="15px">
          <div class="ui heading">Document Name</div>
          <div class="ui heading-bottom">
            {{ extraData?.name }}
          </div>
        </div>
        <div appMargin marginB="15px">
          <div class="ui heading">Document Description</div>
          <div class="ui heading-bottom">{{ extraData?.description }}</div>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 64px;
            border-top: 1px solid #dfdfdf;
          "
        >
          <div style="display: flex; align-items: center">
            <img src="../../../../../assets/icons/document.svg" alt="data" />
            <p
              style="
                margin-left: 20px;
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 16px;
                color: #505050;
              "
            >
              {{ extraData.documentName }}
            </p>
          </div>
          <div>
            <a
              href="{{ baseUrl }}/public/media/?media={{
                extraData.documentPath
              }}"
              target="_blank"
            >
              <i class="eye icon"></i>
            </a>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div class="actions" style="background: transparent; border: none">
    <button class="ui basic primary button" (click)="modal.deny(undefined)">
      Cancel
    </button>
  </div>
</div>
